import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en/translation.json';
import pl from './pl/translation.json';
import { convertLanguageJsonToObject } from './translations';

export const translationsJson = {
  en: {
    translation: en,
  },
  pl: {
    translation: pl,
  },
};

convertLanguageJsonToObject(pl);

export const i18n = i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: translationsJson,
    fallbackLng: 'pl',
    debug: !import.meta.env.PROD,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });
